<template>
  <div>
    <h4 class="custom-16px-400">Lokasi Kejadian:</h4>
    <input
      type="text"
      class="custom-input-grey"
      v-model="detail.Locations"
      @blur="fetchLatLong"
    />
    <p v-if="detail.Latitude && detail.Longitude">
      Lat: {{ detail.Latitude }}, Lng: {{ detail.Longitude }}
    </p>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      detail: {
        Locations: "",
        Latitude: null,
        Longitude: null,
      },
    };
  },
  methods: {
    async fetchLatLong() {
      if (!this.detail.Locations) return;

      const apiUrl = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
        this.detail.Locations
      )}`;

      try {
        const response = await axios.get(apiUrl);
        if (response.data.length > 0) {
          this.detail.Latitude = response.data[0].lat;
          this.detail.Longitude = response.data[0].lon;
          console.log("Lat:", this.detail.Latitude, "Lng:", this.detail.Longitude);
        } else {
          alert("Location not found!");
        }
      } catch (error) {
        console.error("Geocoding error:", error);
      }
    },
  },
};
</script>